import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@/lib/utils";

const badgeVariants = cva(
  "inline-flex items-center rounded-md border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 font-['Raleway']",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-primary text-white shadow hover:bg-primary/80",
        secondary:
          "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive:
          "border-transparent bg-destructive text-destructive-foreground shadow hover:bg-destructive/80",
        containedActive:
          "px-1 bg-[#008bd4] rounded-2xl flex-col justify-start items-center gap-2 inline-flex text-center text-slate-50 text-[9px] font-medium  leading-tight",
        contained:
          "px-1  bg-slate-200 rounded-2xl flex-col justify-start items-center gap-2 inline-flex text-center text-[#04314d]  text-[9px] font-medium leading-tight",
        outlinedActive:
          "px-3 py-1 bg-[#008bd4]/10 border-[#008bd4]/40 rounded-2xl flex-col justify-start items-center gap-2 inline-flex text-center text-[#008bd4] text-xs font-medium  leading-tight",
        outlined:
          "px-3 py-1 bg-white rounded-2xl flex-col justify-start items-center gap-2 inline-flex text-center text-[#04314d] text-xs font-medium leading-tight",
        published:
          "px-3 py-1 bg-green-50 rounded-2xl flex-col justify-start items-center gap-2 inline-flex text-center text-green-700 border-green-200  text-xs font-medium  leading-tight",
        draft:
          "px-3 py-1 bg-blue-50 rounded-2xl border-slate-200 flex-col justify-start items-center gap-2 inline-flex text-center text-blue-700  text-xs font-medium  leading-tight",
        success:
          "border-transparent bg-success text-secondary-foreground hover:bg-success/80",
        outlinedWarning:
          "px-3 py-1 bg-orange-50 rounded-2xl text-orange-700 border-orange-200",
        warning:
          "border-transparent bg-warning text-secondary-foreground hover:bg-warning/80",
        error:
          "px-3 py-1 bg-red-50 rounded-2xl flex-col justify-start items-center gap-2 inline-flex text-center text-red-700 border-red-200 text-xs font-medium leading-tight",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  );
}

export { Badge, badgeVariants };
